const googleApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const getLocationFromPincode = async (pin) => {
    const postalCode = String(pin || "").trim();

    if (postalCode.length < 3) return null;

    try {
        const res = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(postalCode)}&key=${googleApiKey}`
        );

        const data = await res.json();

        if (data.status === "OK") {
            return data;
        }

        return null;

    } catch (error) {
        console.error("Google API Error:", error);
        return null;
    }

};
